import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const HelpDeskIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "HelpDesk",
    children: /*#__PURE__*/_jsx("path", {
      d: "M14.71 27.71H3.29c-1.89 0-3.43-1.54-3.43-3.43V8.29c0-1.89 1.54-3.43 3.43-3.43h11.43a1.14 1.14 0 1 1 0 2.28H3.29c-.63 0-1.14.51-1.14 1.14v16c0 .63.51 1.14 1.14 1.14h11.43a1.14 1.14 0 1 1 0 2.28ZM28.43 27.71h-4.57a1.14 1.14 0 1 1 0-2.28h4.57c.63 0 1.14-.51 1.14-1.14v-16c0-.63-.51-1.14-1.14-1.14h-4.57a1.14 1.14 0 1 1 0-2.28h4.57c1.89 0 3.43 1.54 3.43 3.43v16c0 1.89-1.54 3.43-3.43 3.43ZM19.29 27.71c-.63 0-1.14-.51-1.14-1.14v-3.43a1.14 1.14 0 1 1 2.28 0v3.43c0 .63-.51 1.14-1.14 1.14M19.29 19.71c-.63 0-1.14-.51-1.14-1.14V14a1.14 1.14 0 1 1 2.28 0v4.57c0 .63-.51 1.14-1.14 1.14M19.29 10.57c-.63 0-1.14-.51-1.14-1.14V6a1.14 1.14 0 1 1 2.28 0v3.43c0 .63-.51 1.14-1.14 1.14"
    })
  }));
};